import { RichTextEditorFeatureValue } from "../ControlledRichTextEditor";

export function checkFeature(feature: RichTextEditorFeatureValue) {
  if (feature === undefined) {
    return {
      plugin: true,
      menuButton: true,
      anyDisabled: false,
    };
  }
  if (feature === false) {
    return {
      plugin: false,
      menuButton: false,
      anyDisabled: true,
    };
  }
  return {
    plugin: feature?.disablePlugin !== true,
    menuButton: feature?.disableMenuButton !== true,
    anyDisabled: feature?.disablePlugin === true || feature?.disableMenuButton === true,
  };
}
